import { render, staticRenderFns } from "./OldComments.vue?vue&type=template&id=3fd40070&"
import script from "./OldComments.vue?vue&type=script&lang=js&"
export * from "./OldComments.vue?vue&type=script&lang=js&"
import style0 from "./OldComments.vue?vue&type=style&index=0&media=screen&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports